import { useGetShoppingCartQuery } from 'lib/Api';

export const useShoppingCarts = () => {
  // Always create both shopping carts so session ids are in sync
  const { data: shoppingCartData, isLoading } = useGetShoppingCartQuery({
    isTemporary: false,
  });
  const { data: tempCartData, isLoading: isTempCartLoading } = useGetShoppingCartQuery(
    { isTemporary: true, sessionId: shoppingCartData?.sessionId },
    { skip: isLoading || !shoppingCartData?.sessionId },
  );
  const isCartLoading = isLoading || isTempCartLoading;

  return {
    shoppingCartData,
    tempCartData,
    isCartLoading,
  };
};
